import React from 'react';
import { RelayType } from '@diritto/common/content/constants';
import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { SectionContentTitleText } from 'app-components/home/sections/components/SectionContentTitleText';
import { SectionTextContentMetaInfo } from 'app-components/home/sections/components/SectionTextContentMetaInfo';

interface SectionRankTextItemProps {
  content: ContentRelayDto;
  profile: ProfileLiteRelayDto;
  rank: number;
  onClick?: () => void;
}

export const SectionRankTextItem = ({ content, profile, rank, onClick }: SectionRankTextItemProps) => {
  if (content.relayType !== RelayType.Public) {
    return null;
  }

  if (profile.isDeleted) {
    return null;
  }

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      className="flex gap-[10px] items-center min-w-0 h-[56px] mb-[10px]">
      <p className="text-sm font-bold text-black text-center w-[28px] flex-shrink-0">{rank}</p>
      <div className="flex flex-col flex-1 min-w-0 gap-1">
        <SectionContentTitleText content={content} />
        <SectionTextContentMetaInfo content={content} profile={profile} />
      </div>
    </div>
  );
};

export default SectionRankTextItem;
